var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cxs from 'cxs/component';
import Theme from 'Theme';
class TextArea extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            active: false
        };
        this.handleActive = active => () => this.setState({ active });
        this.handleChange = (event) => {
            console.log('Input- handleChange', event.target.value);
        };
    }
    render() {
        const _a = this.props, { value, label, underline } = _a, props = __rest(_a, ["value", "label", "underline"]);
        const { active } = this.state;
        const unfolded = active || String(value).length > 0;
        return (React.createElement(Wrapper, Object.assign({}, props),
            label ? (React.createElement(Label, { active: active, unfolded: unfolded }, label)) : null,
            React.createElement(StyledInput, { rows: 3, maxLength: 255, value: value, onChange: this.handleChange, underline: underline, active: active, onFocus: this.handleActive(true), onBlur: this.handleActive(false) })));
    }
}
TextArea.defaultProps = {
    underline: true
};
export default TextArea;
const Wrapper = cxs('label')({
    display: 'block',
    width: '100%'
});
const Label = cxs('div')(({ active, unfolded }) => ({
    height: Theme.fontSize.regular,
    fontSize: unfolded ? Theme.fontSize.small : Theme.fontSize.regular,
    color: active ? Theme.color.primary : Theme.color.placeholder,
    transform: `translateY(${unfolded ? 0 : '100%'})`,
    transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'
}));
Label.propTypes = {
    active: PropTypes.bool,
    unfolded: PropTypes.bool
};
const StyledInput = cxs('textarea')(({ underline, active }) => (Object.assign({ width: '100%', height: '100%', transition: 'border-color 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms' }, underline
    ? {
        borderBottom: `${Theme.size.hairline} solid ${active
            ? Theme.color.primary
            : Theme.color.hairline}`
    }
    : undefined)));
StyledInput.propTypes = {
    active: PropTypes.bool,
    underline: PropTypes.bool
};



//////////////////
// WEBPACK FOOTER
// ./src/elements/TextArea.tsx
// module id = 384
// module chunks = 0